import React, { ChangeEvent } from 'react';

import './text-area.scss';

type Props = {
  label: string;
  name: string;
  value: string;
  onChange: (event: ChangeEvent<HTMLTextAreaElement>) => void;
  disabled?: boolean;
};

const TextArea = ({ label, name, value, onChange, disabled = false }: Props) => {
  return (
    <div className="text-area">
      <div className="text-area__label-container">
        <label htmlFor={name}>{label}</label>
      </div>
      <textarea
        className="text-area__input"
        id={name}
        value={value}
        onChange={onChange}
        disabled={disabled}
        autoComplete="off"
      />
    </div>
  );
};

export default TextArea;
